<div class="ha-medical-conditions-section section-wrapper">
	<div id="medical-medical-condition" class="medical-section">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.medical-history.medical-condition.heading'"
				>Medical Conditions</span
			>
		</div>
		<div
			class="radio-btn-label checkbox-text"
			[translate]="'wellness.health-assessment-new.medical-history.medical-condition.form-fields.conditions'">
			Please select current medical conditions:
		</div>
		<!-- <ng-container *ngIf="medicalConditions"> -->
		<div class="checkbox-list" *ngFor="let condition of medicalConditions; let i = index">
			<ng-container *ngIf="i === 0">
				<mat-checkbox
					appAutofocus
					[disabled]="readOnly"
					*ngIf="!condition.hideCheckbox"
					(change)="medicalConditionSelection($event, condition)"
					[checked]="condition.checked"
					>{{ condition.name }}</mat-checkbox
				>
			</ng-container>
			<ng-container *ngIf="i !== 0">
				<mat-checkbox
					[disabled]="readOnly"
					*ngIf="!condition.hideCheckbox"
					(change)="medicalConditionSelection($event, condition)"
					[checked]="condition.checked"
					>{{ condition.name }}</mat-checkbox
				>
			</ng-container>
			<div [formGroup]="medicalConditionForm" class="text-area-wrapper">
				<mat-form-field
					appearance="fill"
					*ngIf="condition.id === medicalConditionsEnum.CANCER_TEXT && showCancerTextBox">
					<mat-label
						><span
							[translate]="
								'wellness.health-assessment-new.medical-history.medical-condition.form-fields.type-of-cancer'
							"
							>Type of cancer</span
						></mat-label
					>
					<textarea
						class="text-area"
						matInput
						cdkTextareaAutosize
						cdkAutosizeMinRows="1"
						cdkAutosizeMaxRows="3"
						formControlName="typeOfCancer"></textarea>
				</mat-form-field>
				<mat-form-field
					appearance="fill"
					*ngIf="condition.id === medicalConditionsEnum.OTHER_REASON && showOtherTextBox">
					<mat-label
						><span
							[translate]="
								'wellness.health-assessment-new.medical-history.medical-condition.form-fields.medical-conditions'
							"
							>Medical conditions</span
						></mat-label
					>
					<textarea
						matInput
						cdkTextareaAutosize
						cdkAutosizeMinRows="1"
						cdkAutosizeMaxRows="4"
						formControlName="medicalConditions"></textarea>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div id="medical-surgical-history">
		<div
			class="radio-btn-label"
			[translate]="'wellness.health-assessment-new.medical-history.medical-condition.form-fields.list-surgeries'">
			Please list any surgeries you have had
		</div>
		<div class="form-field text-area-wrapper">
			<mat-form-field appearance="fill">
				<mat-label
					><span
						[translate]="
							'wellness.health-assessment-new.medical-history.medical-condition.form-fields.surgical-procedures'
						"
						>Surgical procedures</span
					></mat-label
				>
				<textarea
					matInput
					cdkTextareaAutosize
					cdkAutosizeMinRows="1"
					cdkAutosizeMaxRows="4"
					[formControl]="surgeries"></textarea>
			</mat-form-field>
		</div>
	</div>
	<div id="medical-medications">
		<div
			class="radio-btn-label"
			[translate]="'wellness.health-assessment-new.medical-history.medical-condition.form-fields.list-medications'">
			Please list the medications you take, including herbal supplements and vitamins.
		</div>
		<div class="form-field text-area-wrapper">
			<mat-form-field appearance="fill">
				<mat-label
					><span
						[translate]="'wellness.health-assessment-new.medical-history.medical-condition.form-fields.medications'"
						>Medications</span
					></mat-label
				>
				<textarea
					matInput
					cdkTextareaAutosize
					cdkAutosizeMinRows="1"
					cdkAutosizeMaxRows="4"
					[formControl]="medications"></textarea>
			</mat-form-field>
		</div>
	</div>
	<div id="medical-allergies">
		<div class="heading allergy-section">
			<span [translate]="'wellness.health-assessment-new.medical-history.allergies.heading'">Allergies</span>
		</div>
		<div [formGroup]="allergiesForm">
			<div
				class="radio-btn-label"
				[translate]="'wellness.health-assessment-new.medical-history.allergies.form-fields.have-allergies'">
				Do you have an advance directive or living will?
			</div>
			<div>
				<mat-radio-group formControlName="haveAllergies">
					<mat-radio-button [value]="true">
						<span [translate]="'wellness.health-assessment-new.medical-history.allergies.form-fields.option-yes'"
							>Yes</span
						>
					</mat-radio-button>
					<mat-radio-button [value]="false">
						<span [translate]="'wellness.health-assessment-new.medical-history.allergies.form-fields.option-no'"
							>No</span
						>
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="inline-items text-area-wrapper" *ngIf="allergiesForm.get('haveAllergies').value">
				<div class="form-field padding-right-15 w-50">
					<mat-form-field appearance="fill">
						<mat-label
							><span [translate]="'wellness.health-assessment-new.medical-history.allergies.form-fields.medication'"
								>Medications</span
							></mat-label
						>
						<textarea
							formControlName="medication"
							matInput
							cdkTextareaAutosize
							cdkAutosizeMinRows="1"
							cdkAutosizeMaxRows="4"></textarea>
					</mat-form-field>
				</div>
				<div class="form-field w-50">
					<mat-form-field appearance="fill">
						<mat-label
							><span [translate]="'wellness.health-assessment-new.medical-history.allergies.form-fields.reaction'"
								>Reactions</span
							></mat-label
						>
						<textarea
							matInput
							cdkTextareaAutosize
							cdkAutosizeMinRows="1"
							cdkAutosizeMaxRows="4"
							formControlName="reaction"></textarea>
					</mat-form-field>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="next()">
	<button
		class="button button-medium"
		mat-button
		appEheAnalytics
		[data]="{
			pageUrl: '/ha/new/(medical:medical-condition)',
			redirectedTo: '/ha/new/(medical:screening)',
			componentName: 'MedicalConditions',
			id: 'HA Medical Info - Medical Conditions',
			placement: 'ha medical conditions screen'
		}">
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
	</button>
</div>
